import moment from "moment";

/* eslint-disable max-len */
import { cpf, cnpj } from "cpf-cnpj-validator";

export function nameIsvValid(name: string): boolean {
  return /^([A-Za-z&áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]{2,}\s){1}([A-Za-z&áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]{1,}\s?){1,}$/.test(
    name
  );
}

export const regexToURL =
  /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;

export const regexGetHttps = /(https?:\/\/[^ ]*)/g;

export function validateEmail(email: string): boolean {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
}

export const validateDocument = (document: string): boolean => {
  console.log(document, "DOCUMENTO");
  if (!cpf.isValid(document) && !cnpj.isValid(document)) {
    return false;
  }
  return true;
};

export const isValidPhoneNumber = (number: string): boolean => {
  if (number.length === 15) {
    return true;
  }
  return false;
};

// export const isValidDate = (date: string): boolean | undefined => {
//   try {
//     const validateDate = moment(date, "DD/MM/YYYY");
//     const isValid = validateDate?.isValid();
//     const isBefore = validateDate.isBefore();
//     return isValid && isBefore;
//   } catch (error) {
//     /* istanbul ignore next */
//     console.log(error);
//     /* istanbul ignore next */
//     return undefined;
//   }
// };

// export const isInvalidBirthDate = (date: string): string => {
//   if (!isValidDate(date)) {
//     return "A data de nascimento está incorreta";
//   }

//   const birthDate = moment(date, "DD/MM/YYYY");
//   const age = moment().diff(birthDate, "years");

//   if (age > 110) {
//     return "A data de nascimento está incorreta";
//   }

//   if (age < 18) {
//     return "A idade mínima é de 18 anos";
//   }

//   return "";
// };

export function validateHasUppercase(text: string): boolean {
  const hasUppercaseRegex = /.*[A-Z]+.*/g;
  return hasUppercaseRegex.test(text);
}

export function validateHasLowercase(text: string): boolean {
  const hasLowercaseRegex = /.*[a-z]+.*/g;
  return hasLowercaseRegex.test(text);
}

export function validateHasNumber(text: string): boolean {
  const hasNumberRegex = /.*[0-9]+.*/g;
  return hasNumberRegex.test(text);
}

export function validateOnlyNumber(text: string): boolean {
  const onlyNumberRegex = /^\d+$/;
  return onlyNumberRegex.test(text);
}

export function validateMinLength(text: string, minLength: number): boolean {
  return text.length >= minLength;
}

export function validateSpecialCharacters(text: string): boolean {
  const hasSpecialCharacters = /[^A-Za-z0-9]/g;
  return hasSpecialCharacters.test(text);
}

export function isValidPassword(password: string): boolean {
  try {
    if (
      validateHasUppercase(password) &&
      validateHasLowercase(password) &&
      validateHasNumber(password) &&
      validateMinLength(password, 8) &&
      validateSpecialCharacters(password)
    ) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
}

// export function isValidAreaCode(areaCode: string): boolean {
//   return validAreaCodes.includes(areaCode);
// }

export function isValidBarCode(barCode: string): boolean {
  barCode = barCode.replace(/\./g, "");
  barCode = barCode.replace(/ /g, "");
  if (!validateOnlyNumber(barCode)) {
    return false;
  }
  if (barCode.length < 30) {
    return false;
  }
  return true;
}

export const isBillTypeTribute = (value: string): boolean => {
  const tributoType = ["81", "85", "86", "87"];
  const isTribute =
    !!value && value.length >= 2 && tributoType.includes(value.substring(0, 2));

  return isTribute;
};

export const isEmptyObject = (value: any): boolean =>
  Object.keys(value).length === 0 && value.constructor === Object;

export const validateAmount = (
  value: string,
  min: number,
  max: number
): boolean => {
  const tmp = value.replace(/\D/g, "");
  // eslint-disable-next-line radix
  if (parseInt(tmp) <= max && parseInt(tmp) >= min) {
    return true;
  }
  return false;
};

export const isValidDate = (date: string): boolean | undefined => {
  try {
    const validateDate = moment(date, "DD/MM/YYYY");
    const isValid = validateDate?.isValid();
    const isBefore = validateDate.isBefore();
    return isValid && isBefore;
  } catch (error) {
    /* istanbul ignore next */
    console.log(error);
    /* istanbul ignore next */
    return undefined;
  }
};

export const calculateAge = (date: string): number => {
  const birthDate = moment(date, "DD/MM/YYYY");
  const age = moment().diff(birthDate, "years");

  return age;
};

export const isInvalidBirthDate = (date: string): string => {
  if (!isValidDate(date)) {
    return "A data de nascimento está incorreta";
  }

  const age = calculateAge(date);

  if (age > 110) {
    return "A data de nascimento está incorreta";
  }

  if (age < 18) {
    return "Você precisa ter mais de 18 anos para efetuar o cadastro";
  }

  return "";
};

export const cleanNumber = (number: string): string => {
  try {
    number = number.replace(/\D/g, "");
    return number;
  } catch (error) {
    /* istanbul ignore next */
    console.log(error);
    return number;
  }
};

export function hasBlankSpace(text: string): boolean {
  const blankSpace = /\s/g;
  return blankSpace.test(text);
}

export function hasOnlyLetters(text: string): boolean {
  const onlyLetters = /^[a-zA-Z]+$/;
  return onlyLetters.test(text);
}
